﻿import {translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import ReservationBlockType from "../enums/ReservationBlockType";
import {reservationBlockTypeLabel} from "../helpers/enumNaming";
import {ReservationBlock} from "../types/arguments/FormReservation";
import {InstallationByHostData} from "../types/InstallationByHostData";
import {Zones} from "../Zones";

interface ReservationBlockRowProps {
	block: ReservationBlock,
	installation: InstallationByHostData
}

function ReservationBlockRow({block, installation}: ReservationBlockRowProps): JSX.Element {
	return (
		<tr>
			<td>{translation(reservationBlockTypeLabel(block.blockType))}</td>
			<td className="text">{block.street}</td>
			<td className="number">{block.blockType === ReservationBlockType.OnStreet ? block.streetNumber : ""}</td>
			<td className="number">{block.spaceCount}</td>
			<td>{Zones.get(installation, block.zoneId).name}</td>
		</tr>);
}

export interface ReservationBlocksProps {
	blocks: ReservationBlock[];
	installation: InstallationByHostData;
}

export default function ReservationBlocks({blocks, installation}: ReservationBlocksProps): JSX.Element {
	if (blocks == null || blocks.length === 0) {
		return <></>;
	}

	return (
		<div className="card">
			<div role="region" tabIndex={0} className="table--inside-card">
				<table>
					<thead>
					<tr>
						<th>{translation(PermitTranslations.block_type)}</th>
						<th className="text">{translation(PermitTranslations.reservation_block__street)}</th>
						<th className="number">{translation(PermitTranslations.reservation_block__street_number)}</th>
						<th className="number">{translation(PermitTranslations.reservation_block__space_count)}</th>
						<th>{translation(PermitTranslations.reservation_block__area)}</th>
					</tr>
					</thead>
					<tbody>{blocks.map(((block, index) => (
						<ReservationBlockRow key={index} block={block} installation={installation}/>
					)))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
